<template>
  <div class="box">
    <div class="is-clearfix has-margin-bottom-lg">
      <div class="is-pulled-right">
        <router-link :to="{ name: 'products-create' }"
          active-class="" exact-active-class="" class="button is-danger">
          <span class="icon"><i class="fas fa-plus"></i></span>
          <span v-t="'new_resource'" />
        </router-link>
      </div>

      <h1 class="title is-5" v-t="'title'" />
    </div>

    <component
      v-bind:is="formMode === 'new' ? 'ProductsNew' : (formMode === 'edit' ? 'ProductsEdit' : '')"
      :active="formActive" />

    <products-index/>
  </div>
</template>

<script>
import ProductsIndex from '@/components/ProductsIndex'
import ProductsNew from '@/components/ProductsNew'
import ProductsEdit from '@/components/ProductsEdit'

export default {
  name: 'Products',
  components: {
    ProductsIndex,
    ProductsNew,
    ProductsEdit
  },
  data () {
    return {
      formMode: '', // Pode ser 'new' ou 'edit'
      formActive: false
    }
  },
  mounted () {
    this.updateForm(this.$route.name)
  },
  methods: {
    updateForm (routeName) {
      this.formActive = routeName === 'products-create' || routeName === 'products-edit'
      this.formMode = routeName === 'products-create'
        ? 'new' : routeName === 'products-edit'
          ? 'edit' : ''
    }
  },
  watch: {
    '$route' ({ name }) {
      this.updateForm(name)
    }
  },
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "Products",
    "new_resource": "New Product"
  },
  "pt-BR": {
    "title": "Produtos",
    "new_resource": "Novo Produto"
  }
}
</i18n>
